/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Equipment_Place_ShortInputs */

const en_us2_intake_why_equipment_place_short = /** @type {(inputs: Intake_Why_Equipment_Place_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only what you have is picked`)
};

const pt_br2_intake_why_equipment_place_short = /** @type {(inputs: Intake_Why_Equipment_Place_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só o que você tem é escolhido`)
};

const es_419_intake_why_equipment_place_short = /** @type {(inputs: Intake_Why_Equipment_Place_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se elige lo que tienes`)
};

const pt_pt2_intake_why_equipment_place_short = /** @type {(inputs: Intake_Why_Equipment_Place_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só é escolhido o que tens`)
};

const fr_fr2_intake_why_equipment_place_short = /** @type {(inputs: Intake_Why_Equipment_Place_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seul ton matériel est retenu`)
};

const de_de2_intake_why_equipment_place_short = /** @type {(inputs: Intake_Why_Equipment_Place_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur was du hast, wird gewählt`)
};

const it_it2_intake_why_equipment_place_short = /** @type {(inputs: Intake_Why_Equipment_Place_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si sceglie solo ciò che hai`)
};

/**
* | output |
* | --- |
* | "Only what you have is picked" |
*
* @param {Intake_Why_Equipment_Place_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_equipment_place_short = /** @type {((inputs?: Intake_Why_Equipment_Place_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Equipment_Place_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_equipment_place_short(inputs)
	if (locale === "es-419") return es_419_intake_why_equipment_place_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_equipment_place_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_equipment_place_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_equipment_place_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_equipment_place_short(inputs)
	return en_us2_intake_why_equipment_place_short(inputs)
});
export { intake_why_equipment_place_short as "intake.why.equipment_place.short" }